export class CentralStationContactMedicalConditionDto {
    Comment: string;
    MedicalConditionCode: string;
}